<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox ref="navChild"></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<img src="../../assets/img_h5/services/banner_1.webp"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				/>
				<div class="msg_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="400"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">Product Watch List</div>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<!--未登录空状态-->
					<div v-if="!userToken && idsStr.length == 0 && ids.length == 0" class="empty_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/img/watch-list/icon_empty.webp" />
						<div class="title">Your UC reagent List is empty</div>
						<div class="btn_box" @click="logIn">
							<van-button class="btn_el">Sign in to your account</van-button>
						</div>
					</div>
					<!--未登录空状态-->
					<!--顶部内容-->
					<div class="top_box">
						<!--未登录-->
						<div v-if="!userToken && idsStr.length > 0 && ids.length > 0" class="top_box_1"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="title">Current Selection</div>
							<div class="text">
								All products you wish to inquire about are listed below. We will process your request promptly, and our team is always available to answer any questions.
							</div>
							<div class="tips_box">
								Please <span @click="logIn">log in</span> or submit the product list below along with your message, we’ll get back to you shortly.
							</div>
						</div>
						<!--未登录-->
						<!--已登录-->
						<div v-if="userToken" class="top_box_2"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="tabs_box">
								<div class="tab_el" :class="isNow ? 'actived' : ''" @click="isNow = true;">
									Current Selection
									<div v-if="isNow" class="icon"></div>
								</div>
								<div class="tab_el" :class="!isNow ? 'actived' : ''" @click="isNow = false;">
									Historical Selection
									<div v-if="!isNow" class="icon"></div>
								</div>
							</div>
							<div v-if="isNow" class="text">
								All products you wish to inquire about are listed below. We will process your request promptly, and our team is always available to answer any questions.
							</div>
						</div>
						<!--已登录-->
					</div>
					<!--顶部内容-->
					<!--清单-->
					<div class="list_box">
						<!--当前清单-->
						<div v-if="userToken && isNow || isNow && idsStr.length > 0 && ids.length > 0" class="current_list_box">
							<div class="title_box">
								<div class="left">{{ tableData.length }} products in total</div>
								<div class="right" @click="addVisible = true;">
									<van-icon name="add-o" color="#006BB3" size="20" style="top: 4px;" /> Add more
								</div>
							</div>
							<div class="list_box">
								<el-table
									v-loading="tableLoading"
									:data="tableData"
									stripe
									style="width: 100%"
									empty-text="No matching records found"
								>
									<el-table-column prop="" label="" width="auto">
										<template slot-scope="scope">
											<div style="padding: 2px 0;color: #006BB3; cursor: pointer;" @click="goInfo(scope.row)">
												Name: {{ scope.row.product_name || '' }}
											</div>
											<div style="padding: 2px 0;">
												Type: {{ scope.row.cate_name || '' }}
											</div>
											<div style="padding: 2px 0;" v-if="scope.row.format_name.length > 0">
												Format: <span v-for="(value, index) in scope.row.format_name" :key="index">
													{{ index == scope.row.format_name.length - 1 ? value.title : value.title + ', ' }}
												</span>
											</div>
											<div style="padding: 2px 0;">
												Catalog: {{ scope.row.catalog || '' }}
											</div>
											<div style="padding: 2px 0;">
												Qty: <van-stepper
													v-model.number="scope.row.add_num"
													input-width="50px"
													button-size="32px"
													integer
													:long-press="false"
													@blur="numChange(0, scope.row)"
													@minus="numChange(2, scope.row)"
													@plus="numChange(1, scope.row)"
												/>
											</div>
										</template>
									</el-table-column>
									<el-table-column  fixed="right" label="" width="60" align="center">
										<template slot-scope="scope">
											<!-- <el-popconfirm
												confirm-button-text='Confirm'
												cancel-button-text='Cancel'
												title="Are you sure you want to delete it?"
												@confirm="delWatch(scope.row)"
											> -->
												<van-icon name="delete-o" size="22" color="#F56C6C" style="top: 2px;cursor: pointer;" slot="reference" @click="delWatch(scope.row)" />
											<!-- </el-popconfirm> -->
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
						<!--当前清单-->
						<!--历史清单-->
						<div v-if="!isNow" class="history_list_box"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div v-if="historyList.length > 0" class="list_box">
								<div v-for="(value, index) in historyList" :key="value.order_id" class="list_el">
									<div class="title_box">
										<div class="left">
											Query Number: {{ value.order_id }}
										</div>
										<div class="right">
											Date: {{ value.create_time }}
										</div>
									</div>
									<el-table
										class="history_box"
										:data="value.product_lists"
										stripe
										style="width: 100%"
										empty-text="No matching records found"
									>
										<el-table-column prop="title" label="" width="auto">
											<template slot-scope="scope">
												<div style="padding: 2px 0;color: #006BB3; cursor: pointer;" @click="goInfo(scope.row)">
													Name: {{ scope.row.product_name || '' }}
												</div>
												<div style="padding: 2px 0;">
													Type: {{ scope.row.cate_name || '' }}
												</div>
												<div style="padding: 2px 0;" v-if="scope.row.format_name.length > 0">
													Format: <span v-for="(value, index) in scope.row.format_name" :key="index">
														{{ index == scope.row.format_name.length - 1 ? value.title : value.title + ', ' }}
													</span>
												</div>
												<div style="padding: 2px 0;">
													Catalog: {{ scope.row.catalog || '' }}
												</div>
												<div style="padding: 2px 0;">
													Qty: <van-stepper
														disabled
														v-model="scope.row.add_num"
														input-width="50px"
														button-size="32px"
													/>
												</div>
											</template>
										</el-table-column>
									</el-table>
									<div class="bot_box">Message: {{ value.message || '' }}</div>
								</div>
							</div>
							<div v-else>
								<van-empty image="search" description="No historical records found" />
							</div>
						</div>
						<!--历史清单-->
					</div>
					<!--清单-->
					<!--底部内容-->
					<div class="bot_box">
						<!--未登录-->
						<div v-if="!userToken && idsStr.length > 0 && ids.length > 0" class="bot_box_1"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="title">Please complete your profile information</div>
							<el-form :model="ruleForm1" :rules="rules1" label-position="right" ref="ruleForm1" label-width="120px" class="demo-ruleForm" @submit.native.prevent>
								<el-form-item label="First Name" prop="firstName">
									<el-input v-model="ruleForm1.firstName" placeholder="Enter"></el-input>
								</el-form-item>
								<el-form-item label="Last Name" prop="lastName">
									<el-input v-model="ruleForm1.lastName" placeholder="Enter"></el-input>
								</el-form-item>
								<el-form-item label="Email" prop="email">
									<el-input v-model="ruleForm1.email" placeholder="Enter"></el-input>
								</el-form-item>
								<el-form-item label="Country" prop="country">
									<el-input v-model="ruleForm1.country" placeholder="Enter"></el-input>
								</el-form-item>
								<el-form-item label="Your message" prop="">
									<el-input type="textarea" :autosize="{ minRows: 6, maxRows: 10}" v-model="ruleForm1.message" placeholder="Enter"></el-input>
								</el-form-item>
								<div class="btn_box">
									<van-button color="#E37542" class="btn_el" @click="saveEdit1('ruleForm1')">Send</van-button>
								</div>
							</el-form>
						</div>
						<!--未登录-->
						<!--已登录-->
						<div v-if="userToken && isNow" class="bot_box_2"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="left">
								<div class="tit_box">
									<div class="tit">Name:</div>
									<div class="txt">{{ ruleForm2.firstName ? ruleForm2.firstName + ' ' + ruleForm2.lastName : '' }}</div>
								</div>
								<div class="tit_box">
									<div class="tit">Company:</div>
									<div class="txt">{{ ruleForm2.organizationName || '' }}</div>
								</div>
								<div class="tit_box">
									<div class="tit">Address:</div>
									<div v-if="ruleForm2.streetAdress" class="txt">
										{{ ruleForm2.streetAdress ? ruleForm2.streetAdress : '' }}
										<br />
										{{ ruleForm2.city ? ruleForm2.city + ', ' + ruleForm2.state + ' ' + ruleForm2.zipCode : '' }}
									</div>
								</div>
								<div class="tit_box">
									<div class="tit">Email:</div>
									<div class="txt">{{ ruleForm2.email || '' }}</div>
								</div>
								<div class="tit_box">
									<div class="tit">Phone:</div>
									<div class="txt">{{ ruleForm2.phone || '' }}</div>
								</div>
								<div class="tit_box">
									<div class="tit">Customer Number: </div>
									<div class="txt">{{ ruleForm2.customerNumber || '' }}</div>
								</div>
								<div class="tit_box">
									<div class="tit"></div>
									<div class="txt">
										<div class="btn_box" @click="goInformation">
											<van-button class="btn_el">Edit</van-button>
										</div>
									</div>
								</div>
							</div>
							<div class="right">
								<el-form :model="ruleForm2" label-position="top" ref="ruleForm2" label-width="120px" class="demo-ruleForm2" @submit.native.prevent>
									<el-form-item label="Your message" prop="message">
										<el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8}" v-model="ruleForm1.message" placeholder="Enter"></el-input>
									</el-form-item>
									<div class="btn_box">
										<van-button color="#E37542" class="btn_el" @click="submitData">Send</van-button>
									</div>
								</el-form>
							</div>
						</div>
						<!--已登录-->
					</div>
					<!--底部内容-->
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--添加弹框-->
		<div class="add_box">
			<van-popup
				v-if="addVisible"
				v-model="addVisible"
				position="bottom"
				:close-on-click-overlay="false"
				:closeable="false"
				:style="{ width: '100%', height: '90%' }"
			>
				<add @closeDialog="closeVisible"></add>
			</van-popup>
		</div>
		<!--添加弹框-->
		<!--详情弹框-->
		<div class="add_box">
			<van-popup
				v-if="infoVisible"
				v-model="infoVisible"
				position="bottom"
				:close-on-click-overlay="true"
				closeable
				:style="{ width: '100%', height: '90%' }"
			>
				<info :msg="infoData"></info>
			</van-popup>
		</div>
		<!--详情弹框-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import contact from '@/component/h5/contact.vue'  //联系我们组件
import info from '../products/info_h5_model.vue'
import { UPURL } from '@/util/util.js';
import add from "./components/add_h5.vue";
import { getProductGetlist, orderSubmit, userorderList, userInfo, userorderSubmit } from '@/api/public.js';
import md5 from 'js-md5';
export default {
	components:{
		navBox,
		footerBox,
		add,
		info
	},
	data() {
		return {
			isLoading: true,  //界面loading
			ruleForm1: {
				firstName: '',
				lastName: '',
				email: '',
				country: '',
				message: ''
			},
			ruleForm2: {
				firstName: '',
				lastName: '',
				organizationName: '',
				streetAdress: '',
				email: '',
				phone: '',
				customerNumber: '',
				city: '',
				state: '',
				zipCode: ''
			},
			rules1: {
				firstName: [
					{ required: true, message: 'Please enter your First Name', trigger: 'blur' }
				],
				lastName: [
					{ required: true, message: 'Please enter your Last Name', trigger: 'blur' }
				],
				email: [
					{ required: true, message: 'Please enter your Email', trigger: 'blur' }
				],
				country: [
					{ required: true, message: 'Please enter your Country', trigger: 'blur' }
				],
				message: [
					{ required: true, message: 'Please enter your Message', trigger: 'blur' }
				]
			},
			ruleForm2: {
				message: ''
			},
			tableData: [],
			addVisible: false,
			idsStr: [],
			ids: [],
			tableLoading: false,
			userToken: localStorage.getItem('userToken'),
			isNow: true,
			historyList: [],
			infoVisible: false,
			infoData: null
		}
	},
	created(){
		let that = this;
		//获取购物车数据
		if(JSON.parse(localStorage.getItem('idsStr'))) {
			that.idsStr = JSON.parse(localStorage.getItem('idsStr')).split(',');
		}
		if(JSON.parse(localStorage.getItem('ids'))) {
			that.ids = JSON.parse(localStorage.getItem('ids')).split(',');
		}
		if(that.idsStr.length > 0 && that.ids.length > 0) {
			that.getProductList();
		}
		if(that.userToken) {
			//获取用户信息
			userInfo().then(res => {
				that.ruleForm2 = {
					firstName: res.data.first_name,
					lastName: res.data.last_name,
					organizationName: res.data.organization_name,
					streetAdress: res.data.street_address,
					phone: res.data.mobile,
					email: res.data.email,
					customerNumber: res.data.customer_number,
					city: res.data.city,
					state: res.data.state,
					zipCode: res.data.zip_code
				},
				that.isLoading = false;
			});
			//获取历史数据
			userorderList().then(res => {
				that.historyList = res.data;
			});
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	methods: {
		//登录提交订单
		submitData() {
			let that = this;
			if(that.tableData.length > 0) {
				if(that.ruleForm2.firstName && that.ruleForm2.lastName) {
					// that.$confirm('Are you sure to submit your order?', 'Tips', {
					// 	confirmButtonText: 'Confirm',
					// 	cancelButtonText: 'Cancel',
					// 	type: 'warning'
					// }).then(() => {
						that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
						userorderSubmit({
							product_list: that.idsStr.join(','),
							message: that.ruleForm1.message,
							sign: md5(that.idsStr.join(',') + that.ruleForm1.message + 'Jtests2024')
						}).then(res => {
							that.$toast.clear();
							localStorage.removeItem('idsStr');
							localStorage.removeItem('ids');
							that.$toast('Submitted successfully');
							setTimeout(() => {
								window.location.reload();
							}, 1000);
							//获取历史数据
							// userorderList().then(res => {
							// 	that.historyList = res.data;
							// 	that.isNow = false;
							// });
						});
					// }).catch(() => {});
				}else {
					that.$toast('Please complete your personal information first.');
				}
			}else {
				that.$toast('Please add the product you want to purchase first.');
			}
		},
		//未登录提交订单
		saveEdit1(formName) {
			let that = this;
			if(that.tableData.length > 0) {
				that.$refs[formName].validate((valid) => {
					if(valid) {
						if(!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(that.ruleForm1.email)) {
							that.$toast('Email must be formatted correctly.');
							return false;
						}
						// that.$confirm('Are you sure to submit your order?', 'Tips', {
						// 	confirmButtonText: 'Confirm',
						// 	cancelButtonText: 'Cancel',
						// 	type: 'warning'
						// }).then(() => {
							that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
							orderSubmit({
								product_list: that.idsStr.join(','),
								first_name: that.ruleForm1.firstName,
								last_name: that.ruleForm1.lastName,
								email: that.ruleForm1.email,
								country: that.ruleForm1.country,
								message: that.ruleForm1.message,
								sign: md5(that.idsStr.join(',') + that.ruleForm1.firstName + that.ruleForm1.lastName + that.ruleForm1.email + that.ruleForm1.country + 'Jtests2024')
							}).then(res => {
								that.$toast.clear();
								that.ruleForm1 = {
									firstName: '',
									lastName: '',
									email: '',
									country: '',
									message: ''
								}
								localStorage.removeItem('idsStr');
								localStorage.removeItem('ids');
								that.$toast('Submitted successfully');
								setTimeout(() => {
									window.location.reload();
								}, 1000);
							});
						// }).catch(() => {});
					}
				});
			}else {
				that.$toast('Please add the product you want to purchase first.');
			}
		},
		//输入框变化
		numChange(type, value) {
			let that = this;
			let id = value.id;
			let num = null;
			that.tableLoading = true;
			switch(type) {
				case 0:
					if(value.add_num <= 0) {
						num = 1;
					}else {
						num = value.add_num;
					}
				break;
				case 1:
					num = Number(value.add_num + 1)
				break;
				case 2:
					num = Number(value.add_num - 1)
				break;
			}
			//更新购物车数据
			that.ids.forEach((val, index) => {
				if(val == id) {
					that.idsStr[index] = id + '_' + num;
				}
			});
			localStorage.setItem('idsStr', JSON.stringify(that.idsStr.join(',')));
			that.tableLoading = false;
		},
		//删除产品
		delWatch(value) {
			let that = this;
			that.ids.forEach((val, index) => {
				if(val == value.id) {
					//删除
					that.ids.splice(index, 1);
					that.idsStr.splice(index, 1);
					localStorage.setItem('idsStr', JSON.stringify(that.idsStr.join(',')));
					localStorage.setItem('ids', JSON.stringify(that.ids.join(',')));
					that.getProductList();
					that.$toast('Product deleted successfully');
					that.$refs.navChild.initCount();
				}
			});
		},
		//获取购物车列表
		getProductList() {
			let that = this;
			that.tableLoading = true;
			if(JSON.parse(localStorage.getItem('idsStr'))) {
				that.idsStr = JSON.parse(localStorage.getItem('idsStr')).split(',');
			}
			if(JSON.parse(localStorage.getItem('ids'))) {
				that.ids = JSON.parse(localStorage.getItem('ids')).split(',');
			}
			getProductGetlist({
				ids: that.idsStr.join(',')
			}).then(res => {
				that.tableData = res.data;
				that.tableLoading = false;
			});
		},
		//跳转完善个人信息
		goInformation() {
			this.$router.push('/information');
		},
		//跳转登录
		logIn() {
			this.$router.push('/sign-in');
		},
		//跳转详情
		goInfo(value) {
			let that = this;
			if(value.custom) {
				that.infoData = value.custom;
				that.infoVisible = true;
				// that.$router.push({ name: 'ProductInfo', params: { productId: value.custom } });
			}else {
				that.$toast('Product parameter exception, failed to obtain details.');
			}
		},
		//关闭弹框
		closeVisible() {
			let that = this;
			that.addVisible = false;
			that.getProductList();
			that.$refs.navChild.initCount();
		},
		goProducts() {
			this.$router.push('/products');
		},
		goHome() {
			this.$router.push('/');
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #000000;
	font-size: 14px;
	//块1
	.block_1{
		padding: 50px 20px;
		.block_1_main{
			width: 100%;
			margin: 0 auto;
			//清单
			.list_box{
				padding-top: 10px;
				//历史清单
				.history_list_box{
					.list_box{
						.list_el{
							.bot_box{
								padding: 25px 0 40px 0;
								color: #808080;
								font-size: 16px;
							}
							.title_box{
								padding: 10px 20px;
								color: #ffffff;
								background-color: #808080;
								.right{
									padding-top: 5px;
								}
								.left{
									
								}
							}
						}
					}
				}
				//当前清单
				.current_list_box{
					.title_box{
						display: flex;
						align-items: center;
						.right{
							width: auto;
							font-size: 18px;
							color: #006BB3;
							cursor: pointer;
							user-select: none;
						}
						.left{
							flex: 1;
							font-size: 18px;
						}
					}
				}
			}
			//底部
			.bot_box{
				.bot_box_2{
					padding-top: 50px;
					.right{
						.btn_box{
							padding: 10px 0 0 0px;
							.btn_el{
								padding: 4px 16px 1px 16px;
								font-size: 20px;
								border-radius: 6px;
							}
						}
					}
					.left{
						.tit_box{
							display: flex;
							padding: 5px 0;
							.txt{
								flex: 1;
								padding-left: 20px;
								font-size: 18px;
								color: #666666;
								.btn_box{
									padding-top: 10px;
									.btn_el{
										height: 32px;
										padding: 4px 12px 1px 12px;
										font-size: 18px;
										border-radius: 6px;
										color: #006BB3;
									}
								}
							}
							.tit{
								width: 150px;
								text-align: right;
								font-size: 18px;
							}
						}
					}
				}
				.bot_box_1{
					padding-top: 40px;
					.demo-ruleForm{
						width: 100%;
						.btn_box{
							padding: 10px 0;
							text-align: right;
							.btn_el{
								padding: 0px 15px 0px 15px;
								font-size: 16px;
								border-radius: 6px;
							}
						}
					}
					.title{
						padding-bottom: 10px;
						font-size: 24px;
						text-align: center;
					}
				}
			}
			//顶部
			.top_box{
				.top_box_2{
					text-align: center;
					.text{
						padding: 10px 0 0 0;
						font-size: 16px;
					}
					.tabs_box{
						display: flex;
						.tab_el.actived{
							color: #006BB3;
							font-weight: bold;
						}
						.tab_el{
							flex: 1;
							position: relative;
							margin-bottom: 10px;
							font-size: 18px;
							color: #808080;
							cursor: pointer;
							user-select: none;
							.icon{
								position: absolute;
								left: 50%;
								bottom: 0;
								transform: translate(-50%, 0);
								width: 50px;
								height: 2px;
								background-color: #006BB3;
							}
						}
					}
				}
				.top_box_1{
					.tips_box{
						margin-top: 20px;
						padding: 16px;
						background-color: #F6F6F6;
						color: #808080;
						font-size: 16px;
						span{
							color: #0096E3;
							font-size: 16px;
							cursor: pointer;
							user-select: none;
						}
					}
					.text{
						font-size: 16px;
					}
					.title{
						font-size: 32px;
					}
				}
			}
			//空状态
			.empty_box{
				padding: 30px 0 0 0;
				text-align: center;
				.btn_box{
					padding-top: 20px;
					.btn_el{
						padding: 4px 16px 1px 16px;
						font-size: 18px;
						border-radius: 6px;
						color: #006BB3;
					}
				}
				.title{
					padding-top: 18px;
					color: #808080;
					font-size: 24px;
				}
				img{
					width: 80%;
				}
			}
		}
	}
	//banner
	.banner_box{
		position: relative;
		.msg_box{
			width: 100%;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			padding: 0 20px;
			text-align: center;
			.txt{
				font-size: 18px;
				color: #ffffff;
			}
			.tit{
				font-size: 36px;
				color: #ffffff;
			}
		}
		img{
			width: 100%;
		}
	}
}
</style>
<style scoped>
>>> .history_box .el-table__header-wrapper{
	display: none;
}
>>> .list_box .el-table__header-wrapper{
	display: none;
}
</style>